import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
    },
    castButtonContainer: {
        backgroundColor: '#00000050',
        width: 36,
        height: 36,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 24,
    },
    castButton: {
        width: 24,
        height: 24,
    },
});

export default styles;
